module.exports = __webpack_public_path__ + "vue/img/doc-01.f88f98cf.png";